import { useQuery } from '@tanstack/react-query';
import { REACT_QUERY_KEYS } from '@intigral/constant';
import mpx from '../../../actions/mpx_data';
import url from '../../../helpers/url';
import { getCountry } from '../../../helpers/common';
import cdnHandler from '../../../helpers/CDNHandler';

export const useLoadItemDataById = (id: string | null, guid: string | null, isSeries: boolean) => {
    return useQuery({
        queryKey: [REACT_QUERY_KEYS.VOD_DETAILS, url.decodeValue(id)],
        enabled: id !== null,
        queryFn: async () => {
            const decodedValue = url.decodeValue(id);
            const decodedGuid = url.decodeValue(guid);
            const isMovie = !isSeries;
            const itemId = isMovie ? decodedValue : decodedGuid;
            const searchParams = new URLSearchParams();
            searchParams.set('form', 'cjson');
            searchParams.set('byCustomValue', `{PC}{${getCountry()}}`);
            searchParams.set('range', '0-12');

            if (isMovie) {
                searchParams.set('byId', id);
            }
            if (!isMovie) {
                searchParams.set('byGUID', guid);
            }

            const vodResponse = isMovie ? await mpx.getMovieDetail(itemId) : await mpx.getSeriesDetail(itemId);
            const trailerSource = vodResponse?.trailer ?? vodResponse?.vodTrailer ?? null;
            const sourceUrl = trailerSource ? await cdnHandler.resolveURL(trailerSource) : null;

            return { ...vodResponse, trailerUrl: sourceUrl };
        },
        refetchOnWindowFocus: false,
    });
};
